import { debounceTime, takeUntil } from 'rxjs/operators';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  OnInit,
  Provider,
  OnDestroy,
  ViewEncapsulation,
  Input,
} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, UntypedFormGroup, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MatFormFieldControl } from '@angular/material/form-field';

const BIRTH_DAY_FORM_FIELD_CONTROL: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BirthDayComponent),
  multi: true     
};

@Component({
  selector: 'app-birth-day',
  templateUrl: './birth-day.component.html',
  styleUrls: ['./birth-day.component.scss'],
  providers: [
    BIRTH_DAY_FORM_FIELD_CONTROL
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class BirthDayComponent implements OnInit, OnDestroy, ControlValueAccessor, MatFormFieldControl<BirthDayComponent> {
  
  @Input() appearance = '';

  private destroy$ = new Subject();

  days: Array<number> = [];
  months = [
    { id: 1, name: "JANUARY" },
    { id: 2, name: "FEBRUARY" },
    { id: 3, name: "MARCH" },
    { id: 4, name: "APRIL" },
    { id: 5, name: "MAY" },
    { id: 6, name: "JUNE" },
    { id: 7, name: "JULY" },
    { id: 8, name: "AUGUST" },
    { id: 9, name: "SEPTEMBER" },
    { id: 10, name: "OCTOBER" },
    { id: 11, name: "NOVEMBER" },
    { id: 12, name: "DECEMBER" }
  ];
  years: Array<number> = [];

  BirthDay = new UntypedFormGroup({ });

  public onChange: any = () => {
    // empty
  }

  constructor() { 
    this.BirthDay = this.createForm();
  }

  value: BirthDayComponent;
  stateChanges: Observable<void>;
  id: string;
  placeholder: string;
  ngControl: NgControl;
  focused: boolean;
  empty: boolean;
  shouldLabelFloat: boolean;
  required: boolean;
  disabled: boolean;
  errorState: boolean;
  controlType?: string;
  autofilled?: boolean;
  userAriaDescribedBy?: string;

  ngOnInit(): void {
    this.initialDates();
    this.setupEventSubscribers();
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  writeValue(obj: any): void {
    this.inputDate(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    // empty
  }
  setDescribedByIds(ids: string[]): void {
    //
  }
  onContainerClick(event: MouseEvent): void {
    //
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.BirthDay.disable() : this.BirthDay.enable();
  }

  private initialDates(){
    this.initYears();
    this.initDays();
  }

  private initYears() {
    let currentYear = new Date().getFullYear();
    let startYear = currentYear - 100;
    while (startYear <= currentYear) {
      this.years.push(startYear++);
    }
  }
  private initDays(){
    this.days = Array.from(Array(32).keys());
    this.days.shift();
  }

  private inputDate(obj: string | number | Date){
    let inputDate = new Date(obj);
    this.BirthDay.get('day')?.setValue(inputDate.getDate());
    this.BirthDay.get('month')?.setValue(inputDate.getMonth()+1);
    this.BirthDay.get('year')?.setValue(inputDate.getFullYear());
  }

  keyMonthEvent(event){
    let maxLength = 2;
    let keyUp = event.key;
    let previousMonthValue = this.BirthDay.get('keyMonth').value;
    if (previousMonthValue < maxLength) {
      this.BirthDay.get('keyMonth').setValue(previousMonthValue + keyUp);
    } else {
      this.BirthDay.get('keyMonth').setValue('');
      this.BirthDay.get('keyMonth').setValue(keyUp);
    }
  }

  private setupEventSubscribers(){
    
    this.BirthDay.valueChanges
      .pipe( takeUntil(this.destroy$) )
      .subscribe( ()=>{ 
        let 
          year = this.BirthDay.get('year')?.value,
          month = this.BirthDay.get('month')?.value,
          day = this.BirthDay.get('day')?.value;
        
        this.onChange(new Date(year, (month - 1), day)); 
      })

    this.BirthDay.get('keyMonth').valueChanges
      .pipe(
        debounceTime(300),
        takeUntil(this.destroy$)
      )
      .subscribe(v => {
        if(Number(v)<= this.months.length){
          let tempMonth = this.months.find(month=>month.id===Number(v));
          tempMonth ? this.BirthDay.get('month').setValue(tempMonth.id) : null;
        }
        this.BirthDay.get('keyMonth').setValue('',{ emitEvent: false });
      });
  }

  createForm(){
    return new UntypedFormGroup({
      day: new UntypedFormControl({ value: '', disabled: false }),
      month: new UntypedFormControl({ value: '', disabled: false }),
      year: new UntypedFormControl({ value: '', disabled: false }),
      keyMonth: new UntypedFormControl({ value: '', disabled: false })
    });
  }

}
